import React, { useEffect, useRef } from 'react'
import { Flex } from 'theme-ui'
import { Input } from 'ui'
import { LoginSignUpProps } from 'components/LoginSignUpForm/LoginSignUpForm.interface'
import { LoadingState } from 'store/fetchingLogic'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { clearError } from 'store/session'
import {
  StaticPageBody,
  StaticPageHeader,
  StaticPageWrapper,
  TitleSection,
  MainContentContainer,
} from 'components/NewStaticPage'
import { LoginSignUpButton } from 'components/LoginSignUpForm/LoginSignUpButton'
export default function TwoFactorAuthForm({
  handleSubmit,
  handleUpdate,
  form,
  error,
  isLoading,
}: LoginSignUpProps): React.ReactElement {
  const dispatch = useAppDispatch()
  const { loading } = useAppSelector(s => s.session)
  const codeExists: boolean = !!form.code && form.code.length > 0
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    scrollTo(0, 0)
    dispatch(clearError())
    inputRef.current?.focus()
  }, [dispatch])

  return (
    <StaticPageWrapper>
      <StaticPageHeader />
      <StaticPageBody>
        <TitleSection error={error} isLoading={isLoading}>
          Two-Factor Auth
          <Flex
            sx={{
              mt: ['0.8rem', '1.6rem'],
              maxWidth: '35.2rem',
              color: 'lightSteelBlue',
              fontSize: '1.4rem',
              lineHeight: '138%' /* 19.32px */,
              letterSpacing: '0.56px',
            }}
          >
            Use your app to get an authentication code, and enter it below to log in.
          </Flex>
        </TitleSection>
        <MainContentContainer>
          <Flex
            as="form"
            className="b2b-input-autofill"
            sx={{
              width: ['100%', '63rem'],
              position: 'relative',
              height: 'auto',
              py: '4rem',
              px: ['1.6rem', '4rem'],
              justifyContent: 'center',
            }}
            data-testid="login-form"
            onSubmit={(e: React.FormEvent): void => handleSubmit?.(e)}
          >
            <Flex
              sx={{
                flexDirection: 'column',
                gap: '2.4rem',
                width: ['100%', '48rem'],
              }}
            >
              <Input
                ref={inputRef}
                color="aliceBlue"
                label="6-digit Auth Code"
                id="token"
                type="text"
                name="code"
                inputMode="numeric"
                autoComplete="one-time-code"
                data-testid="auth-code"
                aria-label="6-digit Auth Code"
                onChange={(e): void => handleUpdate(e.target)}
                hasText={codeExists}
              />
              <LoginSignUpButton
                data-testid="login-button"
                ariaLabel="log in button"
                isLoading={isLoading}
                disabled={!codeExists || loading === LoadingState.PENDING}
              >
                Log in
              </LoginSignUpButton>
            </Flex>
          </Flex>
        </MainContentContainer>
      </StaticPageBody>
    </StaticPageWrapper>
  )
}
